// Set a cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }

    const isCaseDbDomain = typeof window !== 'undefined' && window.location?.hostname?.endsWith('casedb.co');

    if (isCaseDbDomain) {
        // Clear any host-only cookie first to avoid dual cookies (host + domain)
        document.cookie = name + '=; Max-Age=-1; path=/';
        // Set domain cookie for consistent access across subdomains
        document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=.casedb.co";
        return;
    }

    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Get a cookie
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    let value = null;
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            value = c.substring(nameEQ.length, c.length);
        }
    }
    return value;
}

// Get all cookies
function allCookies() {
    const cookies = document.cookie.split(';');
    return cookies.map(cookie => {
        const [name, ...rest] = cookie.split('=');
        const value = rest.join('=').trim();
        const expiresMatch = document.cookie.match(new RegExp(`${name.trim()}=[^;]+;\\s*expires=([^;]+)`));
        const expires = expiresMatch ? expiresMatch[1] : 'Session';
        return { name: name.trim(), value, expires };
    });
}

// Erase a cookie
function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999; path=/';
    if (typeof window !== 'undefined' && window.location?.hostname?.endsWith('casedb.co')) {
        document.cookie = name + '=; Max-Age=-99999999; path=/; domain=.casedb.co';
    }
}

function setPersistentCookie(name, value) {
    setCookie(name, value, 3650);
}

export { setCookie, getCookie, eraseCookie, allCookies, setPersistentCookie };